import {Box, Card, CardContent, CardHeader, Grow, Typography} from '@mui/material';
import {LockRounded} from '@mui/icons-material';
import GoHome from '../../utils/GoHome';

const Dcma = () =>
    <Box my={4}>
        <Grow in={true}>
            <Card>
                <CardHeader
                    avatar={<LockRounded/>}
                    title='DCMA' subheader='Digital Millennium Copyright Act'
                    action={<GoHome/>}
                />
                <CardContent>
                    <Typography variant='body2' gutterBottom>
                        All the content found on the NHLStreams100 is not hosted on our servers or is created or
                        uploaded
                        by us. NHLStreams100 simply acts as a search engine that finds links from websites like
                        Reddit,
                        Discord, Google and other portals. NHLStreams100 is not responsible for external websites
                        content.
                        If you find that some of the content violates your rights you may request for that content to be
                        brought down at the host that is responsible for the content. That will ensure that the content
                        is removed from NHLStreams100 and other search engines that may have indexed the content.
                    </Typography>
                </CardContent>
            </Card>
        </Grow>
    </Box>;
export default Dcma;